export enum SortingKeys {
  title = 'title',
  seasonPassAdult = 'season-pass-adult',
  seasonPassChild = 'season-pass-child',
  dailyPassAdult = 'daily-pass-adult',
  dailyPassChild = 'daily-pass-child',
}
